/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AuthMeResponse,
  EmployeePermissionsList,
  FranchiseSwitched,
  GetAuthVerifyEmailParams,
  GetSettingsPermissionsAuditParams,
  LoginResponse,
  MyFranchises,
  MyPermissionsResponse,
  PermissionAudit,
  PermissionMatrix,
  PermissionsReplaced,
  PostAuthChangePasswordBody,
  PostAuthCourierSignupBody,
  PostAuthLoginBody,
  PostAuthRegisterBody,
  PostAuthSetupBody,
  PostAuthSwitchFranchiseBody,
  PutSettingsPermissionsEmployeeIdBody,
  PutSettingsPermissionsRoleBody,
  SetupStatus,
  StaffAuthAcknowledged,
  StaffRegistration,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutSettingsPermissionsRoleUrl = (role: string) => {
  return `/api/v1/settings/permissions/${role}`
}

/**
 * @summary Replace a role's permissions
 */
export const putSettingsPermissionsRole = async (
  role: string,
  putSettingsPermissionsRoleBody?: PutSettingsPermissionsRoleBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PermissionsReplaced> => {
  return customFetch<PermissionsReplaced>(getPutSettingsPermissionsRoleUrl(role), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsPermissionsRoleBody),
  })
}

export const getPutSettingsPermissionsRoleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsPermissionsRole>>,
    TError,
    { role: string; data?: PutSettingsPermissionsRoleBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsPermissionsRole>>,
  TError,
  { role: string; data?: PutSettingsPermissionsRoleBody },
  TContext
> => {
  const mutationKey = ['putSettingsPermissionsRole']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsPermissionsRole>>,
    { role: string; data?: PutSettingsPermissionsRoleBody }
  > = (props) => {
    const { role, data } = props ?? {}

    return putSettingsPermissionsRole(role, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsPermissionsRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsPermissionsRole>>
>
export type PutSettingsPermissionsRoleMutationBody = PutSettingsPermissionsRoleBody | undefined
export type PutSettingsPermissionsRoleMutationError = unknown

/**
 * @summary Replace a role's permissions
 */
export const usePutSettingsPermissionsRole = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsPermissionsRole>>,
      TError,
      { role: string; data?: PutSettingsPermissionsRoleBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsPermissionsRole>>,
  TError,
  { role: string; data?: PutSettingsPermissionsRoleBody },
  TContext
> => {
  return useMutation(getPutSettingsPermissionsRoleMutationOptions(options), queryClient)
}
export const getPutSettingsPermissionsEmployeeIdUrl = (id: number) => {
  return `/api/v1/settings/permissions/employee/${id}`
}

/**
 * @summary Replace one employee's permission overrides
 */
export const putSettingsPermissionsEmployeeId = async (
  id: number,
  putSettingsPermissionsEmployeeIdBody?: PutSettingsPermissionsEmployeeIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PermissionsReplaced> => {
  return customFetch<PermissionsReplaced>(getPutSettingsPermissionsEmployeeIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsPermissionsEmployeeIdBody),
  })
}

export const getPutSettingsPermissionsEmployeeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>,
    TError,
    { id: number; data?: PutSettingsPermissionsEmployeeIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>,
  TError,
  { id: number; data?: PutSettingsPermissionsEmployeeIdBody },
  TContext
> => {
  const mutationKey = ['putSettingsPermissionsEmployeeId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>,
    { id: number; data?: PutSettingsPermissionsEmployeeIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return putSettingsPermissionsEmployeeId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsPermissionsEmployeeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>
>
export type PutSettingsPermissionsEmployeeIdMutationBody =
  PutSettingsPermissionsEmployeeIdBody | undefined
export type PutSettingsPermissionsEmployeeIdMutationError = unknown

/**
 * @summary Replace one employee's permission overrides
 */
export const usePutSettingsPermissionsEmployeeId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>,
      TError,
      { id: number; data?: PutSettingsPermissionsEmployeeIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsPermissionsEmployeeId>>,
  TError,
  { id: number; data?: PutSettingsPermissionsEmployeeIdBody },
  TContext
> => {
  return useMutation(getPutSettingsPermissionsEmployeeIdMutationOptions(options), queryClient)
}
export const getPostAuthSwitchFranchiseUrl = () => {
  return `/api/v1/auth/switch-franchise`
}

/**
 * @summary Switch to another branch in the same group
 */
export const postAuthSwitchFranchise = async (
  postAuthSwitchFranchiseBody?: PostAuthSwitchFranchiseBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<FranchiseSwitched> => {
  return customFetch<FranchiseSwitched>(getPostAuthSwitchFranchiseUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthSwitchFranchiseBody),
  })
}

export const getPostAuthSwitchFranchiseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthSwitchFranchise>>,
    TError,
    { data?: PostAuthSwitchFranchiseBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthSwitchFranchise>>,
  TError,
  { data?: PostAuthSwitchFranchiseBody },
  TContext
> => {
  const mutationKey = ['postAuthSwitchFranchise']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthSwitchFranchise>>,
    { data?: PostAuthSwitchFranchiseBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthSwitchFranchise(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthSwitchFranchiseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthSwitchFranchise>>
>
export type PostAuthSwitchFranchiseMutationBody = PostAuthSwitchFranchiseBody | undefined
export type PostAuthSwitchFranchiseMutationError = unknown

/**
 * @summary Switch to another branch in the same group
 */
export const usePostAuthSwitchFranchise = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthSwitchFranchise>>,
      TError,
      { data?: PostAuthSwitchFranchiseBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthSwitchFranchise>>,
  TError,
  { data?: PostAuthSwitchFranchiseBody },
  TContext
> => {
  return useMutation(getPostAuthSwitchFranchiseMutationOptions(options), queryClient)
}
export const getPostAuthSetupUrl = () => {
  return `/api/v1/auth/setup`
}

/**
 * @summary Create the first main administrator
 */
export const postAuthSetup = async (
  postAuthSetupBody?: PostAuthSetupBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getPostAuthSetupUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthSetupBody),
  })
}

export const getPostAuthSetupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthSetup>>,
    TError,
    { data?: PostAuthSetupBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthSetup>>,
  TError,
  { data?: PostAuthSetupBody },
  TContext
> => {
  const mutationKey = ['postAuthSetup']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthSetup>>,
    { data?: PostAuthSetupBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthSetup(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthSetupMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthSetup>>>
export type PostAuthSetupMutationBody = PostAuthSetupBody | undefined
export type PostAuthSetupMutationError = unknown

/**
 * @summary Create the first main administrator
 */
export const usePostAuthSetup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthSetup>>,
      TError,
      { data?: PostAuthSetupBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthSetup>>,
  TError,
  { data?: PostAuthSetupBody },
  TContext
> => {
  return useMutation(getPostAuthSetupMutationOptions(options), queryClient)
}
export const getPostAuthRegisterUrl = () => {
  return `/api/v1/auth/register`
}

/**
 * @summary Register as an employee, where the franchise allows it
 */
export const postAuthRegister = async (
  postAuthRegisterBody?: PostAuthRegisterBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffRegistration> => {
  return customFetch<StaffRegistration>(getPostAuthRegisterUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthRegisterBody),
  })
}

export const getPostAuthRegisterMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthRegister>>,
    TError,
    { data?: PostAuthRegisterBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthRegister>>,
  TError,
  { data?: PostAuthRegisterBody },
  TContext
> => {
  const mutationKey = ['postAuthRegister']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthRegister>>,
    { data?: PostAuthRegisterBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthRegister(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthRegister>>
>
export type PostAuthRegisterMutationBody = PostAuthRegisterBody | undefined
export type PostAuthRegisterMutationError = unknown

/**
 * @summary Register as an employee, where the franchise allows it
 */
export const usePostAuthRegister = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthRegister>>,
      TError,
      { data?: PostAuthRegisterBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthRegister>>,
  TError,
  { data?: PostAuthRegisterBody },
  TContext
> => {
  return useMutation(getPostAuthRegisterMutationOptions(options), queryClient)
}
export const getPostAuthLogoutUrl = () => {
  return `/api/v1/auth/logout`
}

/**
 * @summary Sign out
 */
export const postAuthLogout = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffAuthAcknowledged> => {
  return customFetch<StaffAuthAcknowledged>(getPostAuthLogoutUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostAuthLogoutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, void, TContext>
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, void, TContext> => {
  const mutationKey = ['postAuthLogout']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogout>>, void> = () => {
    return postAuthLogout(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogout>>>

export type PostAuthLogoutMutationError = unknown

/**
 * @summary Sign out
 */
export const usePostAuthLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthLogout>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postAuthLogout>>, TError, void, TContext> => {
  return useMutation(getPostAuthLogoutMutationOptions(options), queryClient)
}
export const getPostAuthLoginUrl = () => {
  return `/api/v1/auth/login`
}

/**
 * @summary Sign in
 */
export const postAuthLogin = async (
  postAuthLoginBody?: PostAuthLoginBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getPostAuthLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthLoginBody),
  })
}

export const getPostAuthLoginMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthLogin>>,
    TError,
    { data?: PostAuthLoginBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthLogin>>,
  TError,
  { data?: PostAuthLoginBody },
  TContext
> => {
  const mutationKey = ['postAuthLogin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthLogin>>,
    { data?: PostAuthLoginBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthLogin(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>
export type PostAuthLoginMutationBody = PostAuthLoginBody | undefined
export type PostAuthLoginMutationError = unknown

/**
 * @summary Sign in
 */
export const usePostAuthLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthLogin>>,
      TError,
      { data?: PostAuthLoginBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthLogin>>,
  TError,
  { data?: PostAuthLoginBody },
  TContext
> => {
  return useMutation(getPostAuthLoginMutationOptions(options), queryClient)
}
export const getPostAuthCourierSignupUrl = () => {
  return `/api/v1/auth/courier-signup`
}

/**
 * @summary An external courier signs up, to be approved by the restaurant
 */
export const postAuthCourierSignup = async (
  postAuthCourierSignupBody?: PostAuthCourierSignupBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffRegistration> => {
  return customFetch<StaffRegistration>(getPostAuthCourierSignupUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthCourierSignupBody),
  })
}

export const getPostAuthCourierSignupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthCourierSignup>>,
    TError,
    { data?: PostAuthCourierSignupBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthCourierSignup>>,
  TError,
  { data?: PostAuthCourierSignupBody },
  TContext
> => {
  const mutationKey = ['postAuthCourierSignup']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthCourierSignup>>,
    { data?: PostAuthCourierSignupBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthCourierSignup(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthCourierSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthCourierSignup>>
>
export type PostAuthCourierSignupMutationBody = PostAuthCourierSignupBody | undefined
export type PostAuthCourierSignupMutationError = unknown

/**
 * @summary An external courier signs up, to be approved by the restaurant
 */
export const usePostAuthCourierSignup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthCourierSignup>>,
      TError,
      { data?: PostAuthCourierSignupBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthCourierSignup>>,
  TError,
  { data?: PostAuthCourierSignupBody },
  TContext
> => {
  return useMutation(getPostAuthCourierSignupMutationOptions(options), queryClient)
}
export const getPostAuthChangePasswordUrl = () => {
  return `/api/v1/auth/change-password`
}

/**
 * @summary Change your own password
 */
export const postAuthChangePassword = async (
  postAuthChangePasswordBody?: PostAuthChangePasswordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffAuthAcknowledged> => {
  return customFetch<StaffAuthAcknowledged>(getPostAuthChangePasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthChangePasswordBody),
  })
}

export const getPostAuthChangePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthChangePassword>>,
    TError,
    { data?: PostAuthChangePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthChangePassword>>,
  TError,
  { data?: PostAuthChangePasswordBody },
  TContext
> => {
  const mutationKey = ['postAuthChangePassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthChangePassword>>,
    { data?: PostAuthChangePasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthChangePassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthChangePassword>>
>
export type PostAuthChangePasswordMutationBody = PostAuthChangePasswordBody | undefined
export type PostAuthChangePasswordMutationError = unknown

/**
 * @summary Change your own password
 */
export const usePostAuthChangePassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthChangePassword>>,
      TError,
      { data?: PostAuthChangePasswordBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthChangePassword>>,
  TError,
  { data?: PostAuthChangePasswordBody },
  TContext
> => {
  return useMutation(getPostAuthChangePasswordMutationOptions(options), queryClient)
}
export const getGetSettingsPermissionsUrl = () => {
  return `/api/v1/settings/permissions`
}

/**
 * @summary What each role may do
 */
export const getSettingsPermissions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PermissionMatrix> => {
  return customFetch<PermissionMatrix>(getGetSettingsPermissionsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPermissionsQueryKey = () => {
  return [`/api/v1/settings/permissions`] as const
}

export const getGetSettingsPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPermissions>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissions>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPermissionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPermissions>>> = ({ signal }) =>
    getSettingsPermissions({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPermissions>>
>
export type GetSettingsPermissionsQueryError = unknown

export function useGetSettingsPermissions<
  TData = Awaited<ReturnType<typeof getSettingsPermissions>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissions<
  TData = Awaited<ReturnType<typeof getSettingsPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissions<
  TData = Awaited<ReturnType<typeof getSettingsPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each role may do
 */

export function useGetSettingsPermissions<
  TData = Awaited<ReturnType<typeof getSettingsPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsPermissionsEmployeesUrl = () => {
  return `/api/v1/settings/permissions/employees`
}

/**
 * @summary Every employee, their role's permissions and their overrides
 */
export const getSettingsPermissionsEmployees = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<EmployeePermissionsList> => {
  return customFetch<EmployeePermissionsList>(getGetSettingsPermissionsEmployeesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPermissionsEmployeesQueryKey = () => {
  return [`/api/v1/settings/permissions/employees`] as const
}

export const getGetSettingsPermissionsEmployeesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPermissionsEmployeesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>> = ({
    signal,
  }) => getSettingsPermissionsEmployees({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPermissionsEmployeesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>
>
export type GetSettingsPermissionsEmployeesQueryError = unknown

export function useGetSettingsPermissionsEmployees<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissionsEmployees<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissionsEmployees<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every employee, their role's permissions and their overrides
 */

export function useGetSettingsPermissionsEmployees<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsEmployees>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPermissionsEmployeesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsPermissionsAuditUrl = (params?: GetSettingsPermissionsAuditParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/settings/permissions/audit?${stringifiedParams}`
    : `/api/v1/settings/permissions/audit`
}

/**
 * @summary Who changed whose permissions
 */
export const getSettingsPermissionsAudit = async (
  params?: GetSettingsPermissionsAuditParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PermissionAudit> => {
  return customFetch<PermissionAudit>(getGetSettingsPermissionsAuditUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPermissionsAuditQueryKey = (
  params?: GetSettingsPermissionsAuditParams,
) => {
  return [`/api/v1/settings/permissions/audit`, ...(params ? [params] : [])] as const
}

export const getGetSettingsPermissionsAuditQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
  TError = unknown,
>(
  params?: GetSettingsPermissionsAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPermissionsAuditQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>> = ({
    signal,
  }) => getSettingsPermissionsAudit(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPermissionsAuditQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPermissionsAudit>>
>
export type GetSettingsPermissionsAuditQueryError = unknown

export function useGetSettingsPermissionsAudit<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
  TError = unknown,
>(
  params: undefined | GetSettingsPermissionsAuditParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissionsAudit>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissionsAudit<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
  TError = unknown,
>(
  params?: GetSettingsPermissionsAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPermissionsAudit>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPermissionsAudit<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
  TError = unknown,
>(
  params?: GetSettingsPermissionsAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who changed whose permissions
 */

export function useGetSettingsPermissionsAudit<
  TData = Awaited<ReturnType<typeof getSettingsPermissionsAudit>>,
  TError = unknown,
>(
  params?: GetSettingsPermissionsAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPermissionsAudit>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPermissionsAuditQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthVerifyEmailUrl = (params?: GetAuthVerifyEmailParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/auth/verify-email?${stringifiedParams}`
    : `/api/v1/auth/verify-email`
}

/**
 * @summary Confirm an e-mail address
 */
export const getAuthVerifyEmail = async (
  params?: GetAuthVerifyEmailParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetAuthVerifyEmailUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthVerifyEmailQueryKey = (params?: GetAuthVerifyEmailParams) => {
  return [`/api/v1/auth/verify-email`, ...(params ? [params] : [])] as const
}

export const getGetAuthVerifyEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthVerifyEmail>>,
  TError = unknown,
>(
  params?: GetAuthVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthVerifyEmailQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthVerifyEmail>>> = ({ signal }) =>
    getAuthVerifyEmail(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthVerifyEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthVerifyEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthVerifyEmail>>
>
export type GetAuthVerifyEmailQueryError = unknown

export function useGetAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getAuthVerifyEmail>>,
  TError = unknown,
>(
  params: undefined | GetAuthVerifyEmailParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthVerifyEmail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof getAuthVerifyEmail>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getAuthVerifyEmail>>,
  TError = unknown,
>(
  params?: GetAuthVerifyEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthVerifyEmail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof getAuthVerifyEmail>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getAuthVerifyEmail>>,
  TError = unknown,
>(
  params?: GetAuthVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Confirm an e-mail address
 */

export function useGetAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getAuthVerifyEmail>>,
  TError = unknown,
>(
  params?: GetAuthVerifyEmailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthVerifyEmail>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthVerifyEmailQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthMyPermissionsUrl = () => {
  return `/api/v1/auth/my-permissions`
}

/**
 * @summary What the signed-in employee may do
 */
export const getAuthMyPermissions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MyPermissionsResponse> => {
  return customFetch<MyPermissionsResponse>(getGetAuthMyPermissionsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMyPermissionsQueryKey = () => {
  return [`/api/v1/auth/my-permissions`] as const
}

export const getGetAuthMyPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMyPermissions>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMyPermissions>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMyPermissionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMyPermissions>>> = ({ signal }) =>
    getAuthMyPermissions({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMyPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMyPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthMyPermissions>>
>
export type GetAuthMyPermissionsQueryError = unknown

export function useGetAuthMyPermissions<
  TData = Awaited<ReturnType<typeof getAuthMyPermissions>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyPermissions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMyPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAuthMyPermissions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMyPermissions<
  TData = Awaited<ReturnType<typeof getAuthMyPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyPermissions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMyPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAuthMyPermissions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMyPermissions<
  TData = Awaited<ReturnType<typeof getAuthMyPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyPermissions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the signed-in employee may do
 */

export function useGetAuthMyPermissions<
  TData = Awaited<ReturnType<typeof getAuthMyPermissions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyPermissions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMyPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthMyFranchisesUrl = () => {
  return `/api/v1/auth/my-franchises`
}

/**
 * @summary The branches this manager can reach
 */
export const getAuthMyFranchises = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MyFranchises> => {
  return customFetch<MyFranchises>(getGetAuthMyFranchisesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMyFranchisesQueryKey = () => {
  return [`/api/v1/auth/my-franchises`] as const
}

export const getGetAuthMyFranchisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMyFranchises>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMyFranchises>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMyFranchisesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMyFranchises>>> = ({ signal }) =>
    getAuthMyFranchises({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMyFranchises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMyFranchisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthMyFranchises>>
>
export type GetAuthMyFranchisesQueryError = unknown

export function useGetAuthMyFranchises<
  TData = Awaited<ReturnType<typeof getAuthMyFranchises>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyFranchises>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMyFranchises>>,
          TError,
          Awaited<ReturnType<typeof getAuthMyFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMyFranchises<
  TData = Awaited<ReturnType<typeof getAuthMyFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthMyFranchises>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMyFranchises>>,
          TError,
          Awaited<ReturnType<typeof getAuthMyFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMyFranchises<
  TData = Awaited<ReturnType<typeof getAuthMyFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMyFranchises>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The branches this manager can reach
 */

export function useGetAuthMyFranchises<
  TData = Awaited<ReturnType<typeof getAuthMyFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMyFranchises>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMyFranchisesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthMeUrl = () => {
  return `/api/v1/auth/me`
}

/**
 * @summary The signed-in employee
 */
export const getAuthMe = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AuthMeResponse> => {
  return customFetch<AuthMeResponse>(getGetAuthMeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMeQueryKey = () => {
  return [`/api/v1/auth/me`] as const
}

export const getGetAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) =>
    getAuthMe({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = unknown

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in employee
 */

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthCheckSetupUrl = () => {
  return `/api/v1/auth/check-setup`
}

/**
 * @summary Whether this franchise still needs its first administrator
 */
export const getAuthCheckSetup = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SetupStatus> => {
  return customFetch<SetupStatus>(getGetAuthCheckSetupUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthCheckSetupQueryKey = () => {
  return [`/api/v1/auth/check-setup`] as const
}

export const getGetAuthCheckSetupQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthCheckSetup>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthCheckSetup>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthCheckSetupQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthCheckSetup>>> = ({ signal }) =>
    getAuthCheckSetup({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthCheckSetup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthCheckSetupQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthCheckSetup>>
>
export type GetAuthCheckSetupQueryError = unknown

export function useGetAuthCheckSetup<
  TData = Awaited<ReturnType<typeof getAuthCheckSetup>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthCheckSetup>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthCheckSetup>>,
          TError,
          Awaited<ReturnType<typeof getAuthCheckSetup>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthCheckSetup<
  TData = Awaited<ReturnType<typeof getAuthCheckSetup>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthCheckSetup>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthCheckSetup>>,
          TError,
          Awaited<ReturnType<typeof getAuthCheckSetup>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthCheckSetup<
  TData = Awaited<ReturnType<typeof getAuthCheckSetup>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthCheckSetup>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether this franchise still needs its first administrator
 */

export function useGetAuthCheckSetup<
  TData = Awaited<ReturnType<typeof getAuthCheckSetup>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthCheckSetup>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthCheckSetupQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
